import React from "react";
import { Button, Form } from "react-bootstrap";
import Spinner from 'react-bootstrap/Spinner';
import { connect } from "react-redux";

import { RAGE_RIGHT } from "../utils/enums";
import { checkRageRightByProps, console } from "../utils/functions";
import { Tooltip, BeendenButton, Navbar, SelectDatenSet } from "../utils/components";
import { fetchData, resetData } from "../reducers/konditionen-reducer";
import ConditionsRange from "./conditionsRange";
import ConditionsAbsolute from "./conditionsAbsolute";
import ConditionsTable from "./conditionsTable";
import { searchListe } from "./searchList";
import CONFIG from "../config";
import { ConditionsPagination } from "./components";

class Conditions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      rows: 10,
      data: null,
      isFetching: false,
      isDirty: false,
      dirty: [],
      labels: [],
      preisLabels: [],
      sort: {
        kennziffer: { active: false, directionUp: false },
        bezeichnung: { active: true, directionUp: false },
        preis_0: { active: false, directionUp: false },
      },
      konditionenSet: [],
      aktiveKonditionen: "",
      search: "",
      changed: false,
      editMode: false,
      readOnly: false,
    };
    if (
      !this.props.rightStorage.isAdmin() ||
      ( // BLB Admin kann Konditionen anderer Mandanten nur lesen
        this.props.configStorage.isBLBAdmin() &&
        !this.props.mandantStorage.isBLBAdmin()
      )
    ) {
      // schaltet alle editiermöglichkeiten aus
      this.state.readOnly = true;
    }
    // bind event listeners to this
    this.sortListe = this.sortListe.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onNavbarChange = this.onNavbarChange.bind(this);
    this.onFilterKonditionen = this.onFilterKonditionen.bind(this);
    this.onTableChange = this.onTableChange.bind(this);
    this.onDefaultChange = this.onDefaultChange.bind(this);
    this.onStufenChange = this.onStufenChange.bind(this);
    this.onKonditionenAbsolutChange = this.onKonditionenAbsolutChange.bind(this);
    this.onKonditionenSetChange = this.onKonditionenSetChange.bind(this);
    this.onUndo = this.onUndo.bind(this);
    this.resetDefaultKondition = this.resetDefaultKondition.bind(this);
    this.conditionsRangeRef = React.createRef();
    this.conditionsAbsoluteRef = React.createRef();
  }

  calculateIsDirty(dirty) {
    if (!Array.isArray(dirty)) return true;
    return dirty.reduce((isDirty, d) => isDirty || !!d, false);
  }

  loadData = async (appType) => {
    if (this.state.isFetching) return;
    let konditionenSet = Array.isArray(this.props.mandantStorage.konditionenSet)
      ? this.props.mandantStorage.konditionenSet
      : [];
    const shopAppType = CONFIG.getShopConfig({
      edelmetall: "edelmetall",
      sorten: "sorten"
    });
    console.log("konditionenSet:", konditionenSet);
    console.log("shopAppType:", shopAppType);
    if (!appType || typeof appType === "object") {
      if (konditionenSet.includes(shopAppType)) {
        appType = shopAppType;
      } else {
        appType = konditionenSet[0];
      }
    }
    if (!appType) return;

    let page = this.state.page;
    let search = this.state.search;
    let changed = this.state.changed;
    if (this.state.aktiveKonditionen !== appType) {
      page = 1;
      search = "";
      changed = false;
    }

    this.setState({ isFetching: true });
    let konditionRequestData = this.props.configStorage.getRequestData(appType + "Konditionen");
    if (this.props.configStorage.isBLBAdmin() && !this.props.mandantStorage.isBLBAdmin()) {
      konditionRequestData.params = { gpNummer: this.props.mandantStorage.gpNummer };
    }
    let res;
    try {
      res = await this.props.dispatch(fetchData({ requestData: konditionRequestData, appType })).unwrap();
    } catch (e) {
      console.error(e);
      this.setState({ isFetching: false, error: e.message, konditionSet: [] });
      return;
    }
    if (!res || res.type === "ERROR") {
      this.setState({ isFetching: false, error: res.error || "Daten konten nicht geladen werden", konditionenSet: [] });
      return;
    }
    const data = this.props.konditionenStorage.getItems();
    const labels = res.listKeys && Array.isArray(res.listKeys.headers) ? res.listKeys.headers : [];
    const preisLabels = res.listKeys && Array.isArray(res.listKeys.preisHeaders) ? res.listKeys.preisHeaders : [];
    this.setState({
      data, isDirty: false, dirty: [], isFetching: false, labels, preisLabels, error: null,
      konditionenSet, aktiveKonditionen: appType, page, search, changed
    });
  };

  onKonditionenSetChange(e) {
    if (!e || !e.currentTarget || !this.state.konditionenSet.includes(e.currentTarget.value)) return;
    if (this.state.isDirty) {
      console.log("display messagebox to save or undo changes");
    }
    let aktiveKonditionen = e.currentTarget.value;
    this.loadData(aktiveKonditionen);
    this.conditionsRangeRef.current.loadData(aktiveKonditionen);
    this.conditionsAbsoluteRef.current.loadData(aktiveKonditionen);
  }

  componentDidMount() {
    if (checkRageRightByProps(this.props) || this.props.configStorage.isBLBAdmin()) {
      this.loadData();
    }
  }

  onSubmit(e) {
    // das formular wird nicht mehr als Ganzes versendet sondern jede Änderung einzeln
    return;
  }

  onNavbarChange(changes) {
    if (!changes) return;
    if (typeof changes.search === "string") {
      let page = this.state.page;
      if (this.state.data.filter(item => searchListe(item, changes.search, this.state.changed)).length < this.state.rows * (this.state.page - 1)) {
        page = 1;
      }
      this.setState({ search: changes.search, page });
    }
    if (changes.page) {
      this.setState({ page: Number(changes.page) });
    }
    if (changes.rows) {
      let rows = Number(changes.rows) || 10;
      // first element in the page
      let pos = (this.state.page - 1) * this.state.rows + 1;
      // new page to display first element
      let page = Math.ceil(pos / rows);
      this.setState({ rows, page });
    }
    if (typeof changes.changed === "boolean") {
      let page = this.state.page;
      if (this.state.data.filter(item => searchListe(item, changes.search, this.state.changed)).length < this.state.rows * (this.state.page - 1)) {
        page = 1;
      }
      this.setState({ changed: !this.state.changed, page });
    }
  }

  onFilterKonditionen() {
    this.onNavbarChange({ changed: true });
    this.setState({ page: 1 });
  }

  resetKondition(idx) {
    // TODO reset all values in data to original value
    const data = this.state.data || [];
    data.forEach(i => i.resetKondition(idx));
    const dirty = [...this.state.dirty];
    dirty[idx] = this.calculateIsDirty(data.map(i => i.isDirty(idx)));
    const isDirty = this.calculateIsDirty(dirty);
    this.setState({ data, isDirty, dirty });
  }

  onTableChange(change) {
    if (!change) return;
    if (change.item) {
      let data = Array.isArray(this.state.data) ? this.state.data : [];
      let item = data.find(i => i.row === change.item.row);
      if (!item) return;
      item.setKondition(change.item.value, change.item.col);
      let dirty = [...this.state.dirty];
      dirty[change.item.col] = this.calculateIsDirty(data.map(i => i.isDirty(change.item.col)));
      let isDirty = this.calculateIsDirty(dirty);
      this.setState({ data, isDirty, dirty });
    } else if (!isNaN(change.resetKondition)) {
      this.resetKondition(change.resetKondition);
    } else if (change.sort) {
      this.setState({ sort: change.sort });
    } else if (typeof change.editMode !== "undefined") {
      this.setState(change);
    }
  }

  onUndo() {
    const data = this.state.data || [];
    const dirty = this.state.dirty.map((isDirty, idx) => {
      if (isDirty) data.forEach(i => i.resetKondition(idx));
      return false;
    });
    this.setState({ data, isDirty: false, dirty });
  }

  sortListe(a, b) {
    const sortIndex = Object.keys(this.state.sort).find(skey => this.state.sort[skey].active);
    const sortDir = this.state.sort[sortIndex].directionUp ? 1 : -1;
    let s1, s2, b1, b2, n1, n2;
    if (String(sortIndex).match(/^preis_[0-9]$/)) {
      const idx = String(sortIndex).replace(/preis_/, "");
      n1 = a && a.preis ? Number(a.preis[idx]) : 0;
      n2 = b && b.preis ? Number(b.preis[idx]) : 0;
      b1 = b2 = "";
    } else {
      s1 = String(a[sortIndex]);
      s2 = String(b[sortIndex]);
      b1 = s1.replace(/^([0-9,]*)(.*)/, "$2").trim().toLowerCase();
      b2 = s2.replace(/^([0-9,]*)(.*)/, "$2").trim().toLowerCase();
      n1 = Number(s1.replace(/^([0-9,]*)(.*)/, "$1"));
      n2 = Number(s2.replace(/^([0-9,]*)(.*)/, "$1"));
    }
    if (b1 === b2) return n1 < n2 ? sortDir : -sortDir;
    return b1 < b2 ? sortDir : -sortDir;
  }

  getListe(data) {
    if (!Array.isArray(data)) return [];
    return data.filter(item => searchListe(item, this.state.search, this.state.changed))
      .sort(this.sortListe)
      .filter((_, idx) => Math.ceil((idx + 1) / this.state.rows) === this.state.page);
  }

  setDefaultKondition(idx) {
    const data = [...(this.state.data || [])];
    const liste = this.getListe(data);
    liste.forEach(i => i.setKondition(i.konditionen[idx].defaultWert, idx));
    let dirty = [...this.state.dirty];
    dirty[idx] = this.calculateIsDirty(data.map(i => i.isDirty(idx)));
    let isDirty = this.calculateIsDirty(dirty);
    this.setState({ data, isDirty, dirty });
  }

  async resetDefaultKondition(e) {
    if (!e) return;
    const target = e.currentTarget || e.target;
    if (!target) return;
    const idx = Number(target.dataset.reset);
    const data = [...(this.state.data || [])];
    const liste = this.getListe(data);
    if (isNaN(idx) || !liste.length) return;
    const kondition = liste[0].konditionen[idx];
    const resetField = kondition.field;
    const konditionRequestData = this.props.configStorage.getRequestData(this.state.aktiveKonditionen + "Konditionen", "post");
    try {
      await this.props.dispatch(resetData({ requestData: konditionRequestData, reset: resetField })).unwrap();
    } catch (e) {
      console.log("k3", e);
      this.setState({ error: e.message });
      return;
    }
    this.setState({ error: null });
    this.loadData(this.state.aktiveKonditionen);
  }

  onDefaultChange(change) {
    if (!change) return this.loadData(this.state.aktiveKonditionen);
    if (!isNaN(change.setDefaultKondition)) {
      this.setDefaultKondition(change.setDefaultKondition);
    }
  }

  onStufenChange(change) {
    console.log("onStufenChange", change);
    if (!change) return this.loadData(this.state.aktiveKonditionen);
  }

  onKonditionenAbsolutChange(change) {
    console.log("onKonditionenAbsolutChange", change);
    if (!change) return this.loadData(this.state.aktiveKonditionen);
  }

  render() {
    if (!checkRageRightByProps(this.props) && !this.props.configStorage.isBLBAdmin()) {
      return (
        <div>Sie haben nicht die benötigten Rechte.</div>
      );
    }
    let konditionenSet = Array.isArray(this.props.mandantStorage.konditionenSet)
      ? this.props.mandantStorage.konditionenSet
      : [];
    let data = this.state.data;
    if (this.state.isFetching) {
      return (
        <Spinner animation="border" role="status" variant="primary">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      );
    }
    if (this.props.configStorage.isBLBAdmin() && !this.props.mandantStorage.isBLBAdmin() && !konditionenSet.length) {
      return <div>
        Diesen Mandant kann keine Konditionen ändern.
      </div>;
    }
    if (!data || !data.length || this.props.konditionenStorage.error) {
      let error = this.state.error;
      if (this.props.konditionenStorage.error) {
        error = this.props.konditionenStorage.error.message;
      }
      return (
        <>
          <SelectDatenSet
            label="Auswahl der Konditionen"
            onChange={this.onKonditionenSetChange}
            value={this.state.aktiveKonditionen}
            dataSet={this.props.mandantStorage.konditionenSet}
          />
          <div>
            <p>Die Konditionen konnten nicht geladen werden</p>
            Es ist ein Fehler aufgetreten: {error}
            <Button variant="default" className="ms-one" onClick={this.loadData}>Aktualisieren</Button>
          </div>
        </>
      );
    }
    let liste = this.getListe(data);
    const { defaultWerte, defaultBetraege } = this.props.konditionenStorage.getDefaultWerte();
    return (
      <div className="konditionen">
        <SelectDatenSet
          label="Auswahl der Konditionen"
          onChange={this.onKonditionenSetChange}
          value={this.state.aktiveKonditionen}
          disabled={this.state.isDirty || this.state.editMode}
          dataSet={this.props.mandantStorage.konditionenSet}
        />
        <h2 className="text-secondary">
          <span className="text-capitalize">{this.state.aktiveKonditionen}</span>
          {" "}Konditionen{!this.state.readOnly ? " anpassen" : " des GP " + this.props.mandantStorage.gpNummer}
        </h2>
        {this.state.error
          ? <div className="alert alert-danger fs-6 p-1">Fehler beim Laden: {this.state.error}</div>
          : null
        }
        <h3>Institutsspezifische Standard-Konditionen (gemäß Ihrer Angaben in Anlage G)</h3>
        <ConditionsTable
          id="defaultWerte"
          defaultWerte={[defaultWerte, defaultBetraege]}
          liste={liste}
          labels={this.state.labels}
          editMode={this.state.editMode}
          readOnly={this.state.readOnly}
          aktiveKonditionen={this.state.aktiveKonditionen}
        />
        <p className="fs-6">
          Weitere Erläuterungen finden Sie auf Seite 3 in der Anlage G zum Kooperationsvertrag.<br />          
        </p>
        <ConditionsRange
          ref={this.conditionsRangeRef}
          id="stufen"
          labels={this.state.labels}
          aktiveKonditionen={this.state.aktiveKonditionen}
          editMode={this.state.editMode}
          readOnly={this.state.readOnly}
          onChange={this.onStufenChange}
        />
        <ConditionsAbsolute
          ref={this.conditionsAbsoluteRef}
          id="absolut"
          labels={this.state.labels}
          aktiveKonditionen={this.state.aktiveKonditionen}
          editMode={this.state.editMode}
          readOnly={this.state.readOnly}
          onChange={this.onKonditionenAbsolutChange}
        />
        <Form onSubmit={this.onSubmit}>
          <h3>Optionale Konditionsanpassung (Kennziffer)</h3>
          <p className="fs-6">
            Hinweis: In diesem Bereich können Sie für einzelne Produkte Sonderkonditionen für den Verkauf hinterlegen
            (z.B. für Aktionen). Die speziell am Produkt hinterlegten Prozentsätze sind fixiert und ändern sich auch bei
            Kursschwankungen nicht. Die im oberen Bereich eingegebenen Schwellenwerte werden hierbei nicht berücksichtigt.
            Produkte, die manuell geändert wurden, sind <span className="mark"> markiert</span>.<br />
            Über den Button „zurücksetzen“ können Sie alle manuellen Anpassungen einer Spalte zurücknehmen, so dass anschließend wieder
            die Schwellenwerte bzw. Standardkonditionen für die Bepreisung ausschlaggebend sind.
          </p>
          <Navbar
            brand="Konditionen"
            pagination={ConditionsPagination}
            searchListe={searchListe}
            list={data}
            page={this.state.page}
            rows={this.state.rows}
            search={this.state.search}
            changed={this.state.changed}
            disabled={this.state.editMode}
            onChange={this.onNavbarChange}
          />
          <ConditionsTable
            id="konditionen"
            liste={liste}
            labels={this.state.labels}
            preisLabels={this.state.preisLabels}
            dirty={this.state.dirty}
            editMode={this.state.editMode}
            readOnly={this.state.readOnly}
            aktiveKonditionen={this.state.aktiveKonditionen}
            onChange={this.onTableChange}
          >
            <tr aria-label="geänderte Konditionen">
              <th colSpan={3} className="changed">
                <div className="d-flex justify-content-end">
                  <Form.Check id="changed" className="w-auto">
                    <Form.Check.Input
                      type="checkbox"
                      className="border"
                      checked={this.state.changed}
                      onChange={this.onFilterKonditionen}
                    />
                    <Form.Check.Label className={""}>
                      geänderte Konditionen
                    </Form.Check.Label>
                  </Form.Check>
                </div>
              </th>
              <th aria-label={this.state.labels[0]}>
                {!this.state.readOnly
                  ? <Button
                    variant="warning"
                    size="sm"
                    className="col ms-2"
                    disabled={this.state.editMode}
                    data-reset="0"
                    onClick={this.resetDefaultKondition}
                  >
                    zurücksetzen
                    <Tooltip>Die Konditionen dieser Spalte werden auf ihren Stufenwert zurückgesetzt</Tooltip>
                  </Button>
                  : null
                }
              </th>
              <th aria-label={this.state.labels[1]}>
                {!this.state.readOnly
                  ? <Button
                    variant="warning"
                    size="sm"
                    className="col ms-2"
                    disabled={this.state.editMode}
                    data-reset="1"
                    onClick={this.resetDefaultKondition}
                  >
                    zurücksetzen
                    <Tooltip>Die Konditionen dieser Spalte werden auf ihren Stufenwert zurückgesetzt</Tooltip>
                  </Button>
                  : null
                }
              </th>
              <th aria-label={this.state.labels[2]}>
                {!this.state.readOnly
                  ? <Button
                    variant="warning"
                    size="sm"
                    className="col ms-2"
                    disabled={this.state.editMode}
                    data-reset="2"
                    onClick={this.resetDefaultKondition}
                  >
                    zurücksetzen
                    <Tooltip>Die Konditionen dieser Spalte werden auf ihren Stufenwert zurückgesetzt</Tooltip>
                  </Button>
                  : null
                }
              </th>
            </tr>
          </ConditionsTable>
          <Navbar
            brand="Konditionen"
            pagination={ConditionsPagination}
            searchListe={searchListe}
            list={data}
            page={this.state.page}
            rows={this.state.rows}
            search={this.state.search}
            changed={this.state.changed}
            disabled={this.state.editMode}
            onChange={this.onNavbarChange}
          />
        </Form>
        {this.props.configStorage.isVerseNeo()
          ? <>
            <a
              href={this.props.configStorage.getBackToLandingPageLink()}
              className="btn btn-info col-12 col-md-3 col-lg-2"
            >
              Zurück zur Startseite
            </a>
            <BeendenButton className="col-12 col-md-3 col-lg-2" />
          </>
          : null
        }
      </div>
    );
  }

}

export default connect(store => {
  return {
    configStorage: store.configStorage,
    mandantStorage: store.mandantStorage,
    konditionenStorage: store.konditionenStorage,
    rightStorage: store.rightStorage, // needed for checkRageRightByProps
    requiredRageRight: [RAGE_RIGHT.RAGE_ADMIN, RAGE_RIGHT.RAGE_BERATER_ZWEI]
  };
})(Conditions);
